import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Route,
  Switch,
  NavLink
} from 'react-router-dom';

import ColorPicker from 'components/colorPicker/ColorPicker';
import Platform1 from './Platform1';
import Platform2 from './Platform2';
import Platform3 from './Platform3';
import './LiveFeedIndex.scss';

import {
  getCurrentMeet
} from 'selectors';


class LiveFeedIndex extends Component {
  state = {
    fontColor: '#FFFFFF',
    backgroundColor: '#000000'
  }

  render() {
    const { meet } = this.props;
    if(!meet) {
      return null;
    }

    const baseUrl = `/meets/${meet._id}`;

    return (
      <div className="live-feed-index">
        <div className="tabs">
          <NavLink to={`${baseUrl}/liveFeed/version1`} className="tab" activeClassName='active'>Version 1</NavLink>
          <NavLink to={`${baseUrl}/liveFeed/version2`} className="tab" activeClassName='active'>Version 2</NavLink>
          <NavLink to={`${baseUrl}/liveFeed/version3`} className="tab" activeClassName='active'>Version 3</NavLink>
        </div>

        <div className="live-feed-content" style={{color: this.state.fontColor, backgroundColor: this.state.backgroundColor}}>
          <div>
            <div className="color-picker-wrapper">
              <label>Font Color: </label>
              <ColorPicker value={this.state.fontColor} onChange={(hex) => this.setState({fontColor: hex})} />
            </div>
            <div className="color-picker-wrapper">
              <label>Background Color: </label>
              <ColorPicker value={this.state.backgroundColor} onChange={(hex) => this.setState({backgroundColor: hex})} />
            </div>
          </div>
          {
            _.map(_.sortBy(meet.platforms, ['name']), (platform) => {
              return (
                <div key={platform._id}>
                  <Switch>
                    <Route path='/meets/:meetId/liveFeed/version1' component={() => <Platform1 platformId={platform._id} />} />
                    <Route path='/meets/:meetId/liveFeed/version2' component={() => <Platform2 platformId={platform._id} />} />
                    <Route path='/meets/:meetId/liveFeed/version3' component={() => <Platform3 platformId={platform._id} />} />
                    <Route path='/meets/:meetId/liveFeed' component={() => <Platform3 platformId={platform._id} />} />
                  </Switch>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props)
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(LiveFeedIndex);
